const messages = {
  title: "Huoltotyöt!",
  description:
    'Palvelimilla tehdään parhaillaan tarvittavia huoltotöitä.<br/><br/>Siksi <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> -palvelu ei ole tällä hetkellä käytettävissäsi.<br/><br/>Pyydämme kärsivällisyyttäsi ja kiitämme ymmärryksestäsi.<br/><br/> Bridgestone-tiimisi',
}
export default {
  messages
}
